<template>
  <div :class="containerClass" @click="onWrapperClick">
    <AppTopBar @menu-toggle="onMenuToggle" />
    <transition name="layout-sidebar">
      <div
        :class="sidebarClass"
        @click="onSidebarClick"
        v-show="isSidebarVisible()"
      >
        <div class="layout-logo">
          <router-link :to="$constants.URL_ERR.REDIRECT">
            <img
              style="width: 125px; height: 125px; border-radius: 10px"
              alt="Logo"
              v-bind:src="logo_img"
            />
          </router-link>
          <div class="company-main-title">{{name}}</div>
        </div>
        <AppProfile />
        <AppMenu :model="menu" @menuitem-click="onMenuItemClick"/>
      </div>
    </transition>
    <div class="admin-layout layout-main">
      <router-view />
    </div>
    <Toast />
    <AppFooter />
  </div>
</template>
<script>
import AppTopBar from "./layout/Topbar";
import AppProfile from "./layout/Profile";
import AppMenu from "./layout/Menu";
import AppFooter from "./layout/Footer";
//import gql from "graphql-tag";
import GetConstants from './../../core/Constants';
var Constants = GetConstants.getConstans();
import ApiRepository from "@/core/ApiRepository";
import AuthenticationApp from "@/core/AuthenticationApp";
// import router from '@/router';
export default {
  name: "AdminLayout",
  components: {
    AppTopBar: AppTopBar,
    AppProfile: AppProfile,
    AppMenu: AppMenu,
    AppFooter: AppFooter,
  },
  computed: {
    containerClass() {
      return [
        "layout-wrapper",
        {
          "layout-overlay": this.layoutMode === "overlay",
          "layout-static": this.layoutMode === "static",
          "layout-static-sidebar-inactive":
            this.staticMenuInactive && this.layoutMode === "static",
          "layout-overlay-sidebar-active":
            this.overlayMenuActive && this.layoutMode === "overlay",
          "layout-mobile-sidebar-active": this.mobileMenuActive,
        },
      ];
    },
    sidebarClass() {
      return [
        "layout-sidebar",
        {
          "layout-sidebar-dark": this.layoutColorMode === "dark",
          "layout-sidebar-light": this.layoutColorMode === "light",
        },
      ];
    },
    logo() {
      return this.layoutColorMode === "dark"
        ? "../../../assets/layout/images/logo.png"
        : "../../../assets/layout/images/logo.png";
    },

  },
  beforeUpdate() {
    if (this.mobileMenuActive)
      this.addClass(document.body, "body-overflow-hidden");
    else this.removeClass(document.body, "body-overflow-hidden");
  },
  mounted() {
    // document.body.style.zoom = "100%"; //zoom web lại 80%
    document.documentElement.style.fontSize = "12px";
    var open = localStorage.getItem("isOpen");
    if (open === undefined || !open) {
      this.staticMenuInactive = false;
    } else {
      this.staticMenuInactive = true;
    }
    setTimeout(() => {
      if (this.$router.currentRoute.path == "/admin/403" ) {
        this.staticMenuInactive = true;
      }
    }, 50);
    var info = AuthenticationApp.getinfoNormal();
    if(info){
      this.name = info.name_company ?? "Công ty TNHH Dịch vụ An toàn lao động VN"
      this.logo_img = info.img_company ?? "../../../assets/layout/images/logo.png";
    }else{
      this.logo_img = "../../../assets/layout/images/logo.png";
    }
    this.menuService();
  },
  watch: {
    $route() {
      setTimeout(() => {
        if (this.$router.currentRoute.path == "/admin/403" ) {
          this.staticMenuInactive = true;
        }
      }, 50);
      this.menuActive = false;
      this.menuKey++;      
    },
  },
  methods: {
    onWrapperClick() {
      if (!this.menuClick) {
        this.overlayMenuActive = false;
        this.mobileMenuActive = false;
      }
      this.menuClick = false;
    },
    onMenuToggle() {
      this.menuClick = true;

      if (this.isDesktop()) {
        if (this.layoutMode === "overlay") {
          this.overlayMenuActive = !this.overlayMenuActive;
        } else if (this.layoutMode === "static") {
          this.staticMenuInactive = !this.staticMenuInactive;
        }
      } else {
        this.mobileMenuActive = !this.mobileMenuActive;
      }

      event.preventDefault();
    },
    onSidebarClick() {
      this.menuClick = true;
    },
    async onMenuItemClick(event) {
      if (event.item && !event.item.items) {
        this.overlayMenuActive = false;
        this.mobileMenuActive = false;
        console.log("event.item===",event.item)
        if (this.$route.path !== event.item.to) {
          if(event.item.is_hse == true){
              window.open(event.item.to, '_blank');
          } else {
              // Mở link mới
              var token = this.$store.getters.token ? this.$store.getters.token : null
              const headers = {
              "Authorization": "Bearer "+token,
              };
              var that = this;
              await ApiRepository.post("/_api/users/get_token_kh", {}, {headers}).then(function (res) {
                  // console.log("res====",res.data)
                  var value = res.data.data;
                  var uri = that.$ConfigEvn.base_url_hse_soft +`/sso-login?menu=`+event.item.hse_soft_role+`&token=`+value.token_callback;
                  // console.log("uri======",uri)
                  window.open(uri, '_blank');
              });
          }
        }
      }
    },
    addClass(element, className) {
      if (element.classList) element.classList.add(className);
      else element.className += " " + className;
    },
    removeClass(element, className) {
      if (element.classList) element.classList.remove(className);
      else
        element.className = element.className.replace(
          new RegExp(
            "(^|\\b)" + className.split(" ").join("|") + "(\\b|$)",
            "gi"
          ),
          " "
        );
    },
    isDesktop() {
      return window.innerWidth > 1024;
    },
    isSidebarVisible() {
      if (this.isDesktop()) {
        if (this.layoutMode === "static") return !this.staticMenuInactive;
        else if (this.layoutMode === "overlay") return this.overlayMenuActive;
        else return true;
      } else {
        return true;
      }
    },
    async menuService() {
      var token = this.$store.getters.token ? this.$store.getters.token : null
      if(token){
        const headers = {
          "Authorization": "Bearer "+token,
        };
        var listMenuSupp = await ApiRepository.post(Constants.API.MODULE_MENU, {}, {headers}).then(function (response) {
          var data = response?.data?.data ?? [];
          // console.log('data menu', data);
          return data
        })
        // console.log('listMenuSupp', listMenuSupp);
        new Promise((resolve) => {
          var listMenu = [];
          if(listMenuSupp) {
            listMenuSupp.map(m => {
              var menu = {};
              if (m?.items) {
                var items = [];
                m.items.map(n=> {
                  listMenu.push(n.to);
                  if (!n?.type) {
                    items.push(n);
                  }
                });
                // console.log(items);
                if (items.length > 0) {
                  menu = m;
                  menu.items = items;
                }
              } else {
                listMenu.push(m.to);
                if (!m?.type) {
                  menu = m;
                }
              }
              if (!this.$commonFuction.isEmptyObject(menu)) {
                this.menu.push(menu);
              }
            });
          }
          resolve(listMenu);
        }).then((menu) => {
          if (!['/admin/403', '/auth/login', '/auth/confirm-email', '/403', '/404', '/redirect', '/admin', '/home'].includes(this.$router.currentRoute.path)) {
            // console.log("this.menu", this.$router.currentRoute.path);
            var pathArr = this.$router.currentRoute.path.split('/');
            if (pathArr.length > 3) {
              pathArr.pop();
            }
            var new_path = pathArr.join("/");
            var checkPath = menu.filter(f => f == new_path);
            if (checkPath.length < 1) {
              // this.$router.push({path: "/admin/403"});
              console.log("Không có quyền truy cập");
            }
          } else {
            if (['/admin/403'].includes(this.$router.currentRoute.path)) {
              this.$router.push({path: this.$router.currentRoute.path});
            } else {
              this.$router.push({path: '/redirect'});
            }
          }
        });
      }
    },
  },
  data() {
    return {
      layoutMode: "static",
      layoutColorMode: "dark",
      staticMenuInactive: false,
      overlayMenuActive: false,
      mobileMenuActive: false,
      //menu:this.menuService(),
      menu: [],
      menuKey: 0,
      name: "Công ty TNHH Dịch vụ An toàn lao động VN",
      logo_img : "../../../assets/layout/images/logo.png",
    };
  },
};
</script>

<style lang="scss">
.manager-title {
  color: #1d3118;
  text-transform: capitalize;
  font-size: 24px;
  margin-bottom: 16px;
  padding-bottom: 10px;
  border-bottom: 1px solid #eeeeee;
  font-weight: 700;
}
.p-column-filter {
  width: 100%;
}

.table-header {
  display: flex;
  justify-content: space-between;
}

.p-datepicker {
  min-width: 25rem;

  td {
    font-weight: 400;
  }
}

.p-paginator {
  .p-paginator-current {
    margin-left: 10px;
    margin-right: auto;
  }

  .p-dropdown {
    margin-left: auto;
    margin-right: 10px;
  }
}

.p-datatable.p-datatable-responsive {
  .p-datatable-header {
    padding: 1rem;
    text-align: left;
    font-size: 1.5rem;
    border: 0 none;
    background: #fff;
  }

  .p-paginator {
    padding: 1rem;
  }

  .p-datatable-thead > tr > th {
    text-align: left;
  }

  .p-datatable-tbody > tr > td {
    cursor: auto;
  }

  .p-dropdown-label:not(.p-placeholder) {
    text-transform: uppercase;
  }
}

/* Responsive */
.p-datatable-responsive .p-datatable-tbody > tr > td .p-column-title {
  display: none;
}

.dropbtn {
  background-color: #3498db;
  color: white;
  padding: 16px;
  font-size: 16px;
  border: none;
  cursor: pointer;
}

/* Dropdown button on hover & focus */
.dropbtn:hover,
.dropbtn:focus {
  background-color: #2980b9;
}

/* The container <div> - needed to position the dropdown content */
.dropdown {
  position: relative;
  display: inline-block;
}

/* Dropdown Content (Hidden by Default) */
.dropdown-content {
  display: none;
  position: absolute;
  background-color: #f1f1f1;
  min-width: 160px;
  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
  z-index: 1;
}

.dropdown-content a {
  color: black;
  padding: 12px 16px;
  text-decoration: none;
  display: block;
}
.dropdown-content a:hover {
  background-color: #ddd;
}
.show {
  display: block;
}
</style>
